
export interface CaseStudyLink {
  label: string;
  href: string;
}

export interface CaseStudy {
  slug: string;
  title: string;
  tagline: string;
  year: string;
  role: string;
  stack: string[];
  links: CaseStudyLink[];
  problem: string;
  approach: string;
  outcome: string;
}

const modules = import.meta.glob<{ default: CaseStudy }>('../content/case-studies/*.json', {
  eager: true,
});

export const CASE_STUDIES: Record<string, CaseStudy> = Object.fromEntries(
  Object.values(modules).map((mod) => [mod.default.slug, mod.default]),
);
